import {Component, OnInit} from '@angular/core';
import {ProductsArticleService} from './products-article.service';
import {StocksService} from './stocks.service';
import {ProductsArticle} from './products-article';
import {AppComponent} from './app.component';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';

import {Router} from '@angular/router';

@Component({
    selector: 'issue-stock_2',
    styleUrls: ['./styles/out-of-ware-order.component.css'],
    templateUrl: './templates/out-of-ware-order.component.html',
    providers: [ProductsArticleService, StocksService, AuthentificationService, TransactionsService, SortTable]
})



export class OutOfWareOrder {
    session_mode: string = "RECEPTION";
    prod_list: Array<any>;
    pannier_list: any;
    validate_bt: boolean = true;
    transaction_name: string = "";
    remark: string = "";
    quantity: any = 1;
    form_not_valid: boolean = false;
    sortedData: any = [];

    constructor(private products_article_service: ProductsArticleService, private stocks_service: StocksService, private app_component: AppComponent, private lots_service: StocksService, private router: Router, private authentification_service: AuthentificationService, private transactions_service: TransactionsService, private sort_table: SortTable) {
        this.CheckUSerSession();
        this.app_component.valTest = '/out-of-ware-order';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetArticlesList(): void {
        this.products_article_service.GetArticlesList().then(prod_list => {this.prod_list = prod_list; this.sortedData = prod_list; this.sort_table.SetDataArray(prod_list, [{value: "name", type: ""}, {value: "stock", type: "number"}]);});

    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }


    Search(): void {

    }

    AddtoPannier(prod: any): void {
        if (prod.stock > 0) {
            this.transactions_service.AddtoPannierOutofWare(prod).then(pannier_list => {this.pannier_list = pannier_list['list']; if (pannier_list['list'].length !== 0) {this.validate_bt = false} });
        }

    }

    LoadSessionOutOfWare() {
        this.transactions_service.LoadSessionOutOfWare().then(session_list => {this.pannier_list = session_list['list']; if (session_list['list'].length !== 0) {this.validate_bt = false} });
    }

    RemoveFromPannier(prod: any): void {
        //console.log(prod);
        this.transactions_service.RemoveFromPannierOutOfWare(prod.id_article).then(pannier_list => {this.pannier_list = pannier_list['list']; if (pannier_list['list'].length === 0) {this.validate_bt = true} });
    }

    EditArticleSession(prod: any): void {
        this.transactions_service.EditArticleSessionOutOfWare(prod.id_article).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
    }


    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
        //  console.log(this.session_mode);
    }

    EditAndValidateModification(prod: any): void {

        if (prod.status === "RECEPTION") {
            console.log(prod.status);
            //console.log(prod.id_article);
            this.EditArticleSession(prod);
        } else if (prod.status === 'MODIFICATION') {
            console.log(prod.status);
            this.ValidateEditArticleSessionPurchase(prod);
        }
    }

    ValidateEditArticleSessionPurchase(prod: any): void {
        console.log(prod);
        if (isNaN(prod.quantity)) {
            prod.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionOutOfWare()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionOutOfWare(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
        }
        //this.transactions_service.ValidateEditArticleSessionPurchase(prod).then(result => {this.pannier_list = result['list']; this.SessionMod(result['list'])});
    }

    ValidatePannier(): void {
        if (this.transaction_name !== "") {
            this.transactions_service.ValidatePannierOutOfWare(this.transaction_name, this.remark).then(result => {this.pannier_list = result['list']; this.transaction_name = ""; this.remark = ""; this.validate_bt = true});
        } else {
            this.form_not_valid = true;
            setTimeout(() => {this.form_not_valid = false;}, 4000);
        }

    }

    ngOnInit(): void {
        this.LoadSessionOutOfWare();
        this.GetArticlesList();
    }

}



// WEBPACK FOOTER //
// ./src/app/out-of-ware-order.component.ts